import React from "react";
import { DialogMessage } from "utils/helpers/DialogMessage";
import { testId } from "tests/testIdStrings";
import { FormattedTypography } from "utils/helpers/FormattedTypography";
import { Stack } from "@mui/material";
import Video from "layout/Components/Video";

type Props = {
  open: boolean;
  close: () => void;
};

export const InfoDialog: React.FC<Props> = (props) => {
  const { open, close } = props;

  const handleClose = () => {
    close();
  };

  return (
    <DialogMessage
      title="test.start.dialog.title"
      open={open}
      close={handleClose}
      primaryButtonText="common.close"
      noCancelButton
      dataTestIdString={testId.common.close}
    >
      <Stack spacing={2}>
        <Video id="getStarted" height="260px" />

        <FormattedTypography
          id={"test.start.dialog.body"}
          values={{
            br: (
              <>
                <br />
                <br />
              </>
            ),
          }}
        />
      </Stack>
    </DialogMessage>
  );
};
